let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("e73cP")).then(() => parcelRequire('5KGDH'));